var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AdminTable',{attrs:{"id":"admin-provider-offer","columns":_vm.columns,"title":`Коллекция provideroffers`,"model-name":"providerOfferModel"},on:{"update:selected":value => (_vm.selected = value),"update:docs":_vm.loadOfferItems},scopedSlots:_vm._u([{key:"body-cell-item",fn:function(props){return [(_vm.offerItems[props.row._id])?_c('AdminSkinCell',{attrs:{"name":_vm.offerItems[props.row._id].marketHashName,"image":_vm.offerItems[props.row._id].image,"rarity":_vm.offerItems[props.row._id].rarity,"phase":_vm.offerItems[props.row._id].phase,"float":_vm.offerItems[props.row._id].float}}):_c('span',{staticClass:"text-grey-6"},[_vm._v(" "+_vm._s(_vm.offerItemsLoading ? "…" : "—")+" ")])]}},{key:"body-cell-state",fn:function(props){return [_c('AdminOfferStateBadge',{attrs:{"value":props.value}})]}},{key:"body-cell-provider",fn:function(props){return [_c('AdminProviderBadge',{attrs:{"value":props.value}})]}},{key:"body-cell-cancelReason",fn:function(props){return [(props.value)?_c('div',{staticClass:"offer-cancel-reason"},[_vm._v(" "+_vm._s(_vm.formatCancelReason(props.value))+" ")]):_c('span',{staticClass:"text-grey-6"},[_vm._v("—")])]}},{key:"top-right",fn:function({ query, search }){return [_c('ApolloMutation',{attrs:{"mutation":gql => gql`
          mutation notifyProviderOfferToPartner($_id: ID!) {
            notifyProviderOfferToPartner(_id: $_id)
          }
        `},on:{"error":error =>
          _vm.$q.notify({
            message: error.message,
            multiLine: true,
            type: 'negative'
          }),"done":() => {
          _vm.$q.notify({
            message: 'Успех',
            multiLine: true,
            type: 'positive'
          });
        }},scopedSlots:_vm._u([{key:"default",fn:function({ mutate, loading, error }){return [_c('q-btn',{attrs:{"label":"Уведомить партнера","color":"primary","disabled":!_vm.lastSelected,"push":"","size":"md","rounded":"","loading":loading},on:{"click":function($event){_vm.multipleMutate(
              mutate,
              _vm.selected.map(v => ({ _id: v._id }))
            )}}})]}}],null,true)}),_c('ApolloMutation',{attrs:{"mutation":gql => gql`
          mutation recheckProviderOffer($_id: ID!) {
            recheckProviderOffer(_id: $_id)
          }
        `},on:{"error":error =>
          _vm.$q.notify({
            message: error.message,
            multiLine: true,
            type: 'negative'
          }),"done":() => {
          _vm.$q.notify({
            message: 'Создалии задачу на перепроверку статуса оффера',
            multiLine: true,
            type: 'positive'
          });
        }},scopedSlots:_vm._u([{key:"default",fn:function({ mutate, loading, error }){return [_c('q-btn',{attrs:{"label":"Перепров. оффер","color":"warning","disabled":!_vm.lastSelected,"push":"","size":"md","rounded":"","loading":loading},on:{"click":function($event){_vm.multipleMutate(
              mutate,
              _vm.selected.map(v => ({ _id: v._id }))
            )}}})]}}],null,true)})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }